"use client";

import { useEffect } from "react";
import { trackEvent } from "@/src/lib/gtm-track";

/**
 * Client component that fires a GTM event on mount.
 * Use inside Server Components to track page views without converting the whole page.
 */
export function TrackView({
  event,
}: {
  event: { name: "view_example_category"; params: { category: string } };
}) {
  useEffect(() => {
    trackEvent(event);
  }, [event]);

  return null;
}
